export const pageHeading = "Notes from the Farm";
export const headerImg = "./images/inner-header-bg.png";
